import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Noise from "@/components/Noise";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import BrandsMarquee from "@/components/BrandsMarquee";
import WorkPortfolio from "@/components/WorkPortfolio";
import Skills from "@/components/Skills";
import Vision from "@/components/Vision";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReducedMotion) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App noise bg-bg text-ink" data-testid="app-root">
      <Noise />
      <Nav />
      <main>
        <Hero />
        <About />
        <Manifesto />
        <Services />
        <BrandsMarquee />
        <WorkPortfolio />
        <Skills />
        <Vision />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
